export class WidgetColorValueConverter {
  toView(color: string, defaultColor?: string) {
    return color ?? defaultColor;
  }

  fromView(color: string) {
    return color === '#000000' ? undefined : color;
  }
}
